import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiRoutes } from '../constants/api-routes.constants';
import { GetUserPermissionsParameters } from './models/user/get-user-permissions-parameters';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly CACHE_DURATION = 60 * 60 * 1000;
  private isUserInAnyGroupLoadedAt: number | null = null;
  isUserInAnyGroup: boolean = false;

  public permissions: string[] = [];
  constructor(private readonly http: HttpClient) {}

  getUserPermissions(parameters: GetUserPermissionsParameters) {
    return this.http
      .get<string[]>(apiRoutes.user.getUserPermissions(parameters.toQueryString()))
      .pipe(tap(permissions => (this.permissions = permissions)));
  }

  getOrFetchIsUserInAnyGroup(): Observable<boolean> {
    if (this.isCacheValid(this.isUserInAnyGroupLoadedAt)) {
      return of(this.isUserInAnyGroup);
    }

    return this.getIsUserInAnyGroup().pipe(
      tap(value => {
        this.isUserInAnyGroup = value;
        this.isUserInAnyGroupLoadedAt = Date.now();
      })
    );
  }

  private readonly _isUserAdmin: boolean | null = null;

  isUserAdmin(): Observable<boolean> {
    if (this._isUserAdmin !== null) {
      return of(this._isUserAdmin);
    }

    return this.http.get<boolean>(apiRoutes.user.isUserAdmin);
  }

  isUserInGroup(groupName: string): Observable<boolean> {
    return this.http.get<boolean>(apiRoutes.user.isUserInGroup(groupName));
  }

  getIsUserInAnyGroup(): Observable<boolean> {
    return this.http.get<boolean>(apiRoutes.user.isUserInAnyGroup());
  }

  hasPermission(permission: string): boolean {
    return this.permissions.includes(permission);
  }

  private isCacheValid(loadedAt: number | null): boolean {
    return !!loadedAt && Date.now() - loadedAt < this.CACHE_DURATION;
  }
}
